import request from 'src/api'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { formatFloat, cleanFloat, isRole } from 'src/misc'
import { addToast } from 'src/toasts'

export default () => {
  $('#offcanvasRight').on('click', '.add_carpet, .add_sanitary_fitting, .add_machinery, .add_work_shift, .add_contract_extra_contract_person', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    if ($(this).hasClass('add_carpet')) {
      $(this).closest('.tab-pane').find('.carpet_rows').prepend($(this).data('fields').replace(regexp, time))
      const amount = $('.carpet_rows select[name*="amount"]:first').val()
      const price = cleanFloat($('.carpet_rows input[name*="price"]:first').val())
      $('.carpet_rows input[name*="total_price"]:first').val(formatFloat(price * amount, true))
      carpetsTotalPrice()
    } else if ($(this).hasClass('add_sanitary_fitting')) {
      $(this).closest('.tab-pane').find('.sanitary_fitting_rows').prepend($(this).data('fields').replace(regexp, time))
      $('.sanitary_fitting_rows .select_sanitary_product_code:first, .sanitary_fitting_rows .select_description:first').select2({
        minimumInputLength: 0,
        dropdownParent: $('#offcanvasRight'),
        width: '100%'
      })
    } else if ($(this).hasClass('add_machinery')) {
      $(this).closest('.tab-pane').find('.machinery_rows').prepend($(this).data('fields').replace(regexp, time))
      machineryTotalPrice()
    } else if ($(this).hasClass('add_work_shift')) {
      $(this).closest('.tab-pane').find('.work_shift_rows').prepend($(this).data('fields').replace(regexp, time))
      workShiftTotalHours()
    } else if ($(this).hasClass('add_contract_extra_contract_person')) {
      $(this).closest('.tab-pane').find('.contract_extra_contract_person_rows').prepend($(this).data('fields').replace(regexp, time))

      let url = 'contract_people_options'
      if (isRole('SUPER_ADMIN')) {
        url += '?customer_id=' + $("#mainForm").attr('action').split('/')[2]
      }

      $('.tab-pane.active .contract_extra_contract_person_row:first .select_contract_person').select2({
        ajax: {
          url: url,
          dataType: 'json'
        },
        allowClear: true,
        dropdownParent: $('#offcanvasRight'),
        placeholder: I18n.t("buttons.new"),
        width: '100%'
      })
    }

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '.remove_carpet_row, .remove_sanitary_fitting_row, .remove_machinery_row, .remove_work_shift_row, .remove_contract_extra_contract_person_row', function(event) {
    dirty = true

    $(this).prev('input[type=hidden]').val('1')
    $(this).closest('.row').addClass('d-none')

    if ($(this).hasClass('remove_carpet_row')) {
      carpetsTotalPrice()
    } else if ($(this).hasClass('remove_machinery_row')) {
      machineryTotalPrice()
    } else if ($(this).hasClass('remove_work_shift_row')) {
      workShiftTotalHours()
    } else if ($(this).hasClass('remove_contract_extra_contract_person_row')) {
      $(this).closest('.contract_extra_contract_person_rows').find('.contract_extra_contract_person_row').not('.d-none').last().find('.hr').addClass('d-none')
    }

    return event.preventDefault()
  })

  $('#offcanvasRight').on('change', '.select_product_code, .select_size, .select_interval', function(event) {
    lockButton(event.currentTarget)

    const customerId = $("#mainForm").attr('action').split('/')[2]
    
    const amount = $(this).closest('.carpet_row').find('select[name*="amount"]').val()
    const interval = $(this).closest('.carpet_row').find('select[name*="interval"]').val()
    if ($(this).hasClass('select_interval')) {
      const val = $(this).closest('.carpet_row').find('select[name*="product_code"]').val()

      request.get('/customers/' + customerId + '/contract_extras/carpet_options?select=product_code&val=' + val + '&interval=' + interval)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $(this).closest('.carpet_row').find('select[name*="product_code"]').val(res.body.product_code)
          $(this).closest('.carpet_row').find('select[name*="size"]').val(res.body.size)
          $(this).closest('.carpet_row').find('.select_interval').val(res.body.interval).trigger('change.select2')
          $(this).closest('.carpet_row').find('input[name*="price"]').val(formatFloat(cleanFloat(res.body.price), true))
          $(this).closest('.carpet_row').find('input[name*="total_price"]').val(formatFloat(cleanFloat(res.body.price) * amount, true))
          carpetsTotalPrice()

          if (res.body.not_found) {
            addToast(I18n.t("errors.not_found_carpet"), 'alert')
          }
        
          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    } else {
      const select = $(event.currentTarget).attr('class').replace('is-invalid', '').replace('form-select select_', '').trim()
      const val = $(this).val()

      request.get('/customers/' + customerId + '/contract_extras/carpet_options?select=' + select + '&val=' + val + '&interval=' + interval)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $(this).closest('.carpet_row').find('select[name*="product_code"]').val(res.body.product_code)
          $(this).closest('.carpet_row').find('select[name*="size"]').val(res.body.size)
          $(this).closest('.carpet_row').find('.select_interval').val(res.body.interval).trigger('change.select2')
          $(this).closest('.carpet_row').find('input[name*="price"]').val(formatFloat(cleanFloat(res.body.price), true))
          $(this).closest('.carpet_row').find('input[name*="total_price"]').val(formatFloat(cleanFloat(res.body.price) * amount, true))
          carpetsTotalPrice()

          if (res.body.not_found) {
            addToast(I18n.t("errors.not_found_carpet"), 'alert')
          }
        
          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    }
  })

  $('#offcanvasRight').on('change', '.select_amount', function(event) {
    lockButton(event.currentTarget)

    const amount = $(this).val()
    const price = cleanFloat($(this).closest('.carpet_row').find('input[name*="price"]').val())
    $(this).closest('.carpet_row').find('input[name*="total_price"]').val(formatFloat(price * amount, true))
    carpetsTotalPrice()

    unlockButton(event.currentTarget)
  })

  $('#offcanvasRight').on('change', '.contract_extra_carpets_price', function(event) {
    const amount = $(this).closest('.carpet_row').find('select[name*="amount"]').val()
    const price = cleanFloat($(this).val())
    $(this).val(formatFloat(price, true))
    $(this).closest('.carpet_row').find('input[name*="total_price"]').val(formatFloat(price * amount, true))
    carpetsTotalPrice()
  })

  $('#offcanvasRight').on('change', '.select_sanitary_product_code, .select_description', function(event) {
    lockButton(event.currentTarget)

    const customerId = $("#mainForm").attr('action').split('/')[2]
    
    let select = 'product_code'
    if ($(event.currentTarget).hasClass('select_description')) {
      select = 'description'
    }
    const val = $(this).val()

    request.get('/customers/' + customerId + '/contract_extras/sanitary_fitting_options?select=' + select + '&val=' + val)
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        $(this).closest('.sanitary_fitting_row').find('select[name*="product_code"]').val(res.body.product_code).trigger('change.select2')
        $(this).closest('.sanitary_fitting_row').find('select[name*="description"]').val(res.body.description).trigger('change.select2')
        $(this).closest('.sanitary_fitting_row').find('input[name*="unit"]').val(res.body.unit)
        $(this).closest('.sanitary_fitting_row').find('input[name*="price"]').val(formatFloat(cleanFloat(res.body.price), true))

        if (res.body.not_found) {
          addToast(I18n.t("errors.not_found_carpet"), 'alert')
        }
      
        unlockButton(event.currentTarget)
      })
      .catch(err => {
        handleErrors(err, event.currentTarget)
      })
  })

  $('#offcanvasRight').on('change', '.contract_extra_sanitary_fitting_price', function(event) {
    const price = cleanFloat($(this).val())
    $(this).val(formatFloat(price, true))
  })

  $('#offcanvasRight').on('change', '.contract_extra_machinery_price', function(event) {
    const price = cleanFloat($(this).val())
    $(this).val(formatFloat(price, true))
    machineryTotalPrice()
  })

  $('#offcanvasRight').on('change', '.contract_extra_work_shift_hours', function(event) {
    const hours = cleanFloat($(this).val())
    $(this).val(formatFloat(hours))
    workShiftTotalHours()
  })

  $('#offcanvasRight').on('change', '.select_contract_person', function(event) {
    const id = $(this).val()
    if (id) {
      $(this).closest('.contract_extra_contract_person_row').find('input[name*="contract_person_id"]').val(id)
      lockButton(event.currentTarget)

      request.get(`/contract_people/${id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $(this).closest('.contract_extra_contract_person_row').find('input[name*="first_name"]').val(res.body.first_name)
          $(this).closest('.contract_extra_contract_person_row').find('input[name*="last_name"]').val(res.body.last_name)
          $(this).closest('.contract_extra_contract_person_row').find('input[name*="phone"]').val(res.body.phone)
          $(this).closest('.contract_extra_contract_person_row').find('select[name*="role"]').val('')
          $(this).closest('.contract_extra_contract_person_row').find('textarea[name*="notes"]').val('')
        
          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    } else {
      $(this).closest('.contract_extra_contract_person_row').find('input[name*="first_name"]').val('')
      $(this).closest('.contract_extra_contract_person_row').find('input[name*="last_name"]').val('')
      $(this).closest('.contract_extra_contract_person_row').find('input[name*="phone"]').val('')
      $(this).closest('.contract_extra_contract_person_row').find('select[name*="role"]').val('')
      $(this).closest('.contract_extra_contract_person_row').find('textarea[name*="notes"]').val('')
    }
  })
}

function carpetsTotalPrice() {
  let total = 0
  let showTotal = false
  $('.carpet_row_total_price').each(function(index,data) {
    if (!$(this).closest('.carpet_row').hasClass('d-none')) {
      const price = cleanFloat($(this).val())
      total += price
      showTotal = true
    }
  })
  $('.carpets_total_price').val(formatFloat(total, true))

  if (showTotal) {
    $('.carpets_total_price').closest('.row').removeClass('d-none')
  } else {
    $('.carpets_total_price').closest('.row').addClass('d-none')
  }
}

function machineryTotalPrice() {
  let total = 0
  let showTotal = false
  $('.machinery_row').not('.d-none').find('input[name*="price"]').each(function(index,data) {
    const price = cleanFloat($(this).val())
    total += price
    showTotal = true
  })
  $('.machinery_total_price').val(formatFloat(total, true))

  if (showTotal) {
    $('.machinery_total_price').closest('.row').removeClass('d-none')
  } else {
    $('.machinery_total_price').closest('.row').addClass('d-none')
  }
}

function workShiftTotalHours() {
  let total = 0
  let showTotal = false
  $('.work_shift_row').not('.d-none').find('input[name*="hours"]').each(function(index,data) {
    const hours = cleanFloat($(this).val())
    total += hours
    showTotal = true
  })
  $('.work_shifts_total_hours').val(formatFloat(total))

  if (showTotal) {
    $('.work_shifts_total_hours').closest('.row').removeClass('d-none')
  } else {
    $('.work_shifts_total_hours').closest('.row').addClass('d-none')
  }
}
